export const API_BASE_URL = process.env.REACT_APP_ENV === 'local' ? 'http://localhost:8080' : 'https://mbox-eqe3es2ona-uc.a.run.app';
